import { jsx } from "react/jsx-runtime";
import { useContext, useMemo } from "react";
import { Box } from "@zillow/constellation";
import { ThemeContext } from "styled-components";
import PropTypes from "prop-types";
import { useLastValidRefinanceValues, useRefinanceColors, abbr } from "./RefinanceCalculator.utils.esm.js";
import withDimensions from "../PaymentDonutChart/withDimensions.esm.js";
import PropInterpolatorWrapper from "../PaymentDonutChart/Chart/common/PropInterpolator.esm.js";
import BarChart from "../PaymentDonutChart/BarChart/BarChart.esm.js";
const YEAR_MONTHS = 12;
const RefinanceBarGraphBase = ({
  containerWidth
}) => {
  const values = useLastValidRefinanceValues();
  const colors = useRefinanceColors();
  const theme = useContext(ThemeContext);
  const dataPoints = useMemo(() => {
    const newDataPoints = [{
      label: "Costs",
      value: values.fields.fees,
      color: colors.costsColor
    }];
    const maybePlotDataPoint = ({
      yearsAtDataPoint
    }) => {
      const monthsAtDataPoint = yearsAtDataPoint * YEAR_MONTHS;
      if (monthsAtDataPoint === 0 || values.calculations.savingsSchedule.length < monthsAtDataPoint) {
        return;
      }
      newDataPoints.push({
        label: `${yearsAtDataPoint}yrs`,
        value: values.calculations.savingsSchedule[monthsAtDataPoint - 1].totalSavings,
        color: colors.lifetimeSavingsColor
      });
    };
    const totalYears = values.calculations.savingsSchedule.length / YEAR_MONTHS;
    maybePlotDataPoint({
      yearsAtDataPoint: 1
    });
    maybePlotDataPoint({
      yearsAtDataPoint: Math.round(totalYears / 3 * 2)
    });
    maybePlotDataPoint({
      yearsAtDataPoint: Math.floor(totalYears)
    });
    return newDataPoints.map((item) => ({
      ...item,
      value: item.value > 0 ? item.value : 0
    }));
  }, [values.calculations.savingsSchedule, values.fields.fees, colors.costsColor, colors.lifetimeSavingsColor]);
  return /* @__PURE__ */ jsx(Box, { sx: {
    fontSize: "$fontSizes.body",
    height: "150px"
  }, children: /* @__PURE__ */ jsx(BarChart, { legend: false, data: dataPoints, width: containerWidth, height: 150, tickTextStroke: theme.constellation.colors.textLight, axesColor: theme.constellation.colors.backgroundLight, xAxisFormatter: (x) => `$${abbr(x)}` }) });
};
RefinanceBarGraphBase.propTypes = {
  containerWidth: PropTypes.number.isRequired
};
const DimensionedThemedRefinanceBarGraph = withDimensions(RefinanceBarGraphBase, {
  defaultHeight: 150,
  defaultWidth: 311
});
const RefinanceBarGraph = PropInterpolatorWrapper(DimensionedThemedRefinanceBarGraph);
export {
  RefinanceBarGraph as default
};
